import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import _ from "lodash";
import { Loader } from "src/components/loader";
import { toast } from "react-toastify";
import * as XLSX from "xlsx";
import IconDownload from "src/assets/images/icon_download.svg";
import { saveAs } from "file-saver";

import './style.scss'


import { Button, TextField } from "@mui/material";
import { GetError, convertIsoToLocalDateTime, convertLocalToUTCDateTime } from "src/constant";
import { GetExcelDataforReconciliation, PostReconciliation, getAllReconcileData } from "src/thunks/reports";
import moment from "moment";

export const Monthly = ({ data }) => {
  /** redux store useDispatch & useSelector ------------------------------ **/
  const dispatch = useDispatch();

  const { filterAllData } = useSelector((state) => state.goodsin);
  const { isDropdownOpenFlagValue } = useSelector((state) => state.dashboard);
  const { signoutModelOpenFlag } = useSelector((state) => state.auth);


  /** hooks useState ----------------------------------------------------- **/
  const [monthlyData, setMonthlyData] = useState([]);
  const [loadingState, setLoadingState] = useState(true)

  /** Variable declarations----------------------------------------------------- **/
  const filterData = filterAllData["Reconsilition"];

  /** hooks useEffect----------------------------------------------------- **/
  const dataManipulation = (data) => {
    return data?.map((d) => {
      let temp = { ...d }
      temp["transactionDate"] = `${moment(filterData?.fromDate).format("YYYY-MM-DD")}T${moment().format("HH:mm")}`
      return temp
    })
  }

  useEffect(() => {
    setLoadingState(false)
    let newData = dataManipulation(data)
    setMonthlyData([...newData]);
  }, [data]);

  const onchangeMethodHandler = (id, label, value) => {
    let data = _.cloneDeep(monthlyData)
    data[id][label] = value
    data[id][`${label}_err`] = false
    setMonthlyData([...data])
  }

  const lookupValues = useSelector((state) => state.lookup);
  let filterDataLookup = _.find(lookupValues?.data, (d) => d?.typeName === "ItemStorageType")

  const saveData = async (index, newdata) => {
    try {
      let token = false
      let findOriginalData = _.cloneDeep(monthlyData[index])

      if (!findOriginalData?.space) {
        findOriginalData['space_err'] = true
        token = true
      }
      if (!findOriginalData?.transactionDate) {
        findOriginalData['transactionDate_err'] = true
        token = true
      }
      // if (!findOriginalData?.notes) {
      //   findOriginalData['notes_err'] = true
      //   token = true
      // }

      let data = _.cloneDeep(monthlyData)
      data[index] = findOriginalData
      setMonthlyData([...data])
      if (!token) {
        if (parseFloat(newdata?.space) === parseFloat(newdata?.currentAllocatedSpace)) {
          toast.warning("space is same as current allocation space");
        } else {
          let payload = []
          let loadingDateTime = convertIsoToLocalDateTime(
            `${newdata?.transactionDate}:00.00Z`,
            "DD-MMM-YYYY, HH:mm"
          );
          payload = [{
            "projectId": newdata?.projectId || 0,
            "depotId": newdata?.DepotId || 0,
            "transactionDate": new Date(loadingDateTime),
            "spaceType": newdata?.spaceType || "0",
            "space": parseFloat((parseFloat(newdata?.space) - parseFloat(newdata?.currentAllocatedSpace)).toFixed(2)),
            "notes": newdata?.notes || "",
            "projectName":newdata?.project,
            "clientName":newdata?.client

          }]
          let res = await dispatch(PostReconciliation({
            data: {
              "reconcilationRequest": [...payload]
            }
          })).unwrap();
          if (res) {
            toast.success("reconcilition changed");
            let data = {
              fromDate: filterData?.fromDate ? moment(filterData?.fromDate).format("YYYY-MM-DD") : moment().format("YYYY-MM-DD"),
              DepotIds: [filterData?.depotId?.id || 0],
              ClientIds: [filterData?.clientId?.id || 0],
              ProjectIds: [filterData?.projectId?.id || 0],
              spaceType: [(filterData?.spaceType?.value) || (filterDataLookup ? filterDataLookup?.id : 21)],
            };
            await dispatch(getAllReconcileData({ ...data }))
          }
        }
      }

    } catch (error) {
      toast.error(GetError(error?.response?.data?.errors) || "something issue");
    }

  }
  const generateHeaders = (tableData, weeksData) => {
    const headers = [
      "RECONCILED ON",
      "TRANSACTION DATE",
      "DEPOT",
      "CLIENT",
      "PROJECT",
      "SPACE TYPE",
      "RECONCILED SPACE (M2)",
      "NOTES",
    ];
    return headers;
  };
  const saveExcelFile = (
    tableData,
    dateFromStr,
    dateToStr,
    depotStr,
    clientStr,
    projectStr,
    weeksData
  ) => {

    let userDetails = JSON.parse(localStorage.getItem("userDetails"))

    const headers = generateHeaders(tableData, weeksData);
    let AdminHeaderChanges = [
      ["Date:", `${moment(dateFromStr).format("DD-MMM-YYYY")} ${dateToStr ? "To  " + moment(dateToStr).format("DD-MMM-YYYY") : ""}`],
      ["Depot:", depotStr?.name || "All Depot"],
      ["Client:", clientStr?.name || "All Client"],
      ["Project:", projectStr?.name || "All Project"]
    ]
    let ProjectManagerHeaderChanges = [
      ["Date:", `${moment(dateFromStr).format("DD-MMM-YYYY")} ${dateToStr ? "To  " + moment(dateToStr).format("DD-MMM-YYYY") : ""}`],
      ["Project:", projectStr?.name || "All Project"]
    ]

    let activeheader = userDetails?.roles == "ProjectManager" ? ProjectManagerHeaderChanges : AdminHeaderChanges

    const worksheet = XLSX.utils.aoa_to_sheet([
      ...activeheader,
      [],
      [],
      headers,
      ...tableData.map((d) => {
        const rowData = [
          convertLocalToUTCDateTime(`${d.reconciledOn}.00Z`, "DD-MM-YYYY,HH:mm"),
          convertLocalToUTCDateTime(`${d.transactionDate}.00Z`, "DD-MM-YYYY,HH:mm"),
          d.depotName,
          d.clientName,
          d.projectName,
          d.spaceType === "exterior" ? "External" : "Internal",
          d.space,
          d.notes,
        ];
        return rowData;
      }),
    ]);

    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Report");

    // Generate the Excel file buffer
    const excelBuffer = XLSX.write(workbook, {
      bookType: "xlsx",
      type: "array",
    });

    // Convert buffer to Blob and save the file
    const data = new Blob([excelBuffer], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });
    const customFileName = `Reconciliation report ${moment().format(
      "DD:MMM:YYYY:HH:mm"
    )}.xlsx`;
    saveAs(data, customFileName);
  };

  const Print = async () => {
    try {
      const depot = filterData?.depotId || "All Depot";
      const client = filterData?.clientId || "All Client";
      const project = filterData?.projectId || "All Project";

      let data = {
        fromDate: filterData?.fromDate ? moment(filterData?.fromDate).format("YYYY-MM-DD") : moment().format("YYYY-MM-DD"),
        DepotIds: [filterData?.depotId?.id || 0],
        ClientIds: [filterData?.clientId?.id || 0],
        ProjectIds: [filterData?.projectId?.id || 0],
        spaceType: [(filterData?.spaceType?.value) || (filterDataLookup ? filterDataLookup?.id : 21)],
      };
      let responseForExcel = await dispatch(GetExcelDataforReconciliation({ ...data })).unwrap();
      await saveExcelFile(
        responseForExcel,
        filterData?.fromDate,
        filterData?.toDate,
        depot,
        client,
        project,
      );
    } catch (error) {
      toast.error(GetError(error?.response?.data?.errors) || "something issue");

    }
  };

  if (loadingState) {
    return <Loader />;
  }
  return (
    <div
      style={{ paddingLeft: 16, background: "#ffffff" }}
      className={`${isDropdownOpenFlagValue == true || signoutModelOpenFlag == true
        ? "add-overlay-for-depot-dropdown"
        : ""
        }`}
    >
      <div
        className="table-responsive"
        style={{ height: window.innerHeight - 100 }}
      >
        <div className="d-flex justify-content-end  me-3 mt-3">
        </div>
        <table
          className="table goodsin-table table-borderless"
          style={{ width: "100%" }}
        >
          <thead className="goodsin-table-header">
            <tr>
              <th scope="col" className={`text-uppercase text-primary`}>
                <div
                  style={{
                    fontFamily: "Montserrat-Regular",
                    fontSize: 12,
                    height: 50,
                    display: "flex",
                    alignItems: "center",
                    width: 150,
                  }}
                >
                  Depot
                </div>
              </th>
              <th scope="col" className={`text-uppercase text-primary`}>
                <div
                  style={{
                    fontFamily: "Montserrat-Regular",
                    fontSize: 12,
                    height: 50,
                    display: "flex",
                    alignItems: "center",
                    width: 150,
                  }}
                >
                  Client
                </div>
              </th>
              <th scope="col" className={`text-uppercase text-primary`}>
                <div
                  style={{
                    fontFamily: "Montserrat-Regular",
                    fontSize: 12,
                    height: 50,
                    display: "flex",
                    alignItems: "center",
                    width: 150,
                  }}
                >
                  Project
                </div>
              </th>
              <th scope="col" className={`text-uppercase text-primary`}>
                <div
                  style={{
                    fontFamily: "Montserrat-Regular",
                    fontSize: 12,
                    height: 50,
                    display: "flex",
                    alignItems: "center",
                    width: 150,
                  }}
                >
                  Type
                </div>
              </th>
              <th scope="col" className={`text-uppercase text-primary`}>
                <div
                  style={{
                    fontFamily: "Montserrat-Regular",
                    fontSize: 12,
                    height: 50,
                    display: "flex",
                    alignItems: "center",
                    width: 200,
                  }}
                >
                  Total Allocated Sapce
                </div>
              </th>
              <th scope="col" className={`text-uppercase text-primary`}>
                <div
                  style={{
                    fontFamily: "Montserrat-Regular",
                    fontSize: 12,
                    height: 50,
                    display: "flex",
                    alignItems: "center",
                    width: 200
                  }}
                >
                  Total Released Space
                </div>
              </th>
              <th scope="col" className={`text-uppercase text-primary`}>
                <div
                  style={{
                    fontFamily: "Montserrat-Regular",
                    fontSize: 12,
                    height: 50,
                    display: "flex",
                    alignItems: "center",
                    width: 200,
                  }}
                >
                  Current Allocated Space
                </div>
              </th>
              <th scope="col" className={`text-uppercase text-primary`}>
                <div
                  style={{
                    fontFamily: "Montserrat-Regular",
                    fontSize: 12,
                    height: 50,
                    display: "flex",
                    alignItems: "center",
                    width: 150,
                  }}
                >
                  Space
                </div>
              </th>
              <th scope="col" className={`text-uppercase text-primary`}>
                <div
                  style={{
                    fontFamily: "Montserrat-Regular",
                    fontSize: 12,
                    height: 50,
                    display: "flex",
                    alignItems: "center",
                    width: 150,
                  }}
                >
                  Transaction Date
                </div>
              </th>
              <th scope="col" className={`text-uppercase text-primary`}>
                <div
                  style={{
                    fontFamily: "Montserrat-Regular",
                    fontSize: 12,
                    height: 50,
                    display: "flex",
                    alignItems: "center",
                    width: 150,
                  }}
                >
                  Notes
                </div>
              </th>
              <th scope="col" className={`text-uppercase text-primary`}>
                <div
                  style={{
                    fontFamily: "Montserrat-Regular",
                    fontSize: 12,
                    height: 50,
                    display: "flex",
                    alignItems: "center",
                    width: 150,
                  }}
                >
                  ACTION
                </div>
              </th>
            </tr>
          </thead>
          <tbody className="goods-table-body">
            {monthlyData.length > 0 &&
              monthlyData.map((d, index) => {
                return (
                  <tr
                    key={`monthlyReportSA${index}`}
                    className="reports-table-body-style-items-tr"

                  >
                    <th scope="col">
                      <div
                        style={{
                          fontFamily: "Montserrat-Regular",
                          fontSize: 14,
                          minHeight: "50px",
                          display: "flex",
                          alignItems: "center",
                        }}
                      >
                        {d.depot}
                      </div>
                    </th>
                    <th scope="col">
                      <div
                        style={{
                          fontFamily: "Montserrat-Regular",
                          fontSize: 14,
                          minHeight: "50px",
                          display: "flex",
                          alignItems: "center",
                        }}
                      >
                        {d.client}
                      </div>
                    </th>
                    <th scope="col">
                      <div
                        style={{
                          fontFamily: "Montserrat-Regular",
                          fontSize: 14,
                          minHeight: "50px",
                          display: "flex",
                          alignItems: "center",
                          paddingLeft: 10,
                        }}
                      >
                        {
                          d?.project || ""
                        }
                      </div>
                    </th>
                    <th scope="col">
                      <div
                        style={{
                          fontFamily: "Montserrat-Regular",
                          fontSize: 14,
                          minHeight: "50px",
                          display: "flex",
                          alignItems: "center",
                          paddingLeft: 10,
                        }}
                      >
                        {
                          d?.spaceTypeName || ""
                        }
                      </div>
                    </th>
                    <th scope="col">
                      <div
                        style={{
                          fontFamily: "Montserrat-Regular",
                          fontSize: 14,
                          minHeight: "50px",
                          display: "flex",
                          alignItems: "center",
                        }}
                      >
                        {d?.totalAllocatedSapce || 0}
                      </div>
                    </th>
                    <th scope="col">
                      <div
                        style={{
                          fontFamily: "Montserrat-Regular",
                          fontSize: 14,
                          minHeight: "50px",
                          display: "flex",
                          alignItems: "center",
                          width: "150px",
                          wordBreak: "break-word"

                        }}
                      >
                        {d?.totalReleasedSpace || 0}
                      </div>
                    </th>
                    <th scope="col">
                      <div
                        style={{
                          fontFamily: "Montserrat-Regular",
                          fontSize: 14,
                          minHeight: "50px",
                          display: "flex",
                          alignItems: "center",
                        }}
                      >
                        {
                          d?.currentAllocatedSpace || 0
                        }
                      </div>
                    </th>
                    <th scope="col">
                      <div
                        style={{
                          fontFamily: "Montserrat-Regular",
                          fontSize: 14,
                          minHeight: "50px",
                          display: "flex",
                          alignItems: "center",
                        }}
                      >

                        <input
                          type="number"
                          placeholder="Space"
                          value={d?.space}
                          onChange={({ target }) => onchangeMethodHandler(index, "space", target.value)}
                          variant="outlined"
                          id="standard-basic"
                          style={d?.space_err ? { height: 42, width: "100%", border: "1px solid red" } : { height: 42, width: "100%" }}
                        />
                      </div>
                    </th>
                    <th scope="col">
                      <div
                        className="dateandtimePicker"
                        style={{
                          fontFamily: "Montserrat-Regular",
                          fontSize: 14,
                          minHeight: "50px",
                          display: "flex",
                          alignItems: "center",
                        }}
                      >
                        <TextField
                          id="datetime-local"
                          type="datetime-local"
                          className={{
                            width: 200,
                          }}
                          defaultValue={d?.transactionDate}
                          onChange={({ target }) => {
                            onchangeMethodHandler(index, "transactionDate", target?.value)
                          }}
                          InputLabelProps={{
                            shrink: true,
                          }}
                          style={d?.transactionDate_err ? { height: 42, width: "100%", border: "1px solid red" } : { height: 42, width: "100%" }}
                          InputProps={{
                            inputProps: { step: 300 }, // 5 min intervals
                          }}
                          inputProps={{
                            step: 300, // 5 min intervals
                          }}
                        />
                      </div>
                    </th>
                    <th scope="col">
                      <div
                        style={{
                          fontFamily: "Montserrat-Regular",
                          fontSize: 14,
                          minHeight: "50px",
                          display: "flex",
                          alignItems: "center",
                        }}
                      >
                        <input
                          type="text"
                          placeholder="Notes"
                          value={d?.notes}
                          onChange={({ target }) => onchangeMethodHandler(index, "notes", target.value)}
                          variant="outlined"
                          id="standard-basic"
                          style={{ height: 42, width: "100%" }}

                        />
                      </div>
                    </th>
                    <th scope="col">
                      <div
                        style={{
                          fontFamily: "Montserrat-Regular",
                          fontSize: 14,
                          minHeight: "50px",
                          display: "flex",
                          alignItems: "center",
                        }}
                      >
                        < Button
                          // disabled={(d?.space && d?.transactionDate && d?.notes) ? false : true}
                          variant="outlined"
                          type="submit"
                          onClick={() => saveData(index, d)}
                        >
                          Save
                        </Button>
                      </div>
                    </th>
                  </tr>
                );
              })}
          </tbody>
        </table>
      </div>
      <div className="d-flex justify-content-end me-3">
        <Button
          disabled={monthlyData?.length <= 0 ? true : false}
          variant="outlined"
          className={`mt-2 save-report-btn-style ms-2 ${monthlyData.length <= 0 ? "fade-out" : ""
            }`}
          startIcon={
            <img src={IconDownload} width={17} height={17} alt="new"></img>
          }
          type="submit"
          onClick={() => Print()}
        >
          Save Report
        </Button>
      </div>

    </div >
  );
};
